(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["fui"] = factory(require("react"));
	else
		root["fui"] = factory(root["react"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__39155__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 13394:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f=__webpack_require__(39155),k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}__webpack_unused_export__=l;exports.jsx=q;__webpack_unused_export__=q;


/***/ }),

/***/ 39155:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__39155__;

/***/ }),

/***/ 64922:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(13394);
} else {}


/***/ }),

/***/ 69122:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 81301:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"firmColor":"#5d3b84","secondaryColor":"silver","successColor":"#4ab675","i":"src-components-Icon-styles_i","smallIcon":"src-components-Icon-styles_smallIcon","disabled":"src-components-Icon-styles_disabled","greyIcon":"src-components-Icon-styles_greyIcon"});

/***/ }),

/***/ 87083:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ Icon_BaseIcon)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(39155);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(69122);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/Icon/styles.scss
var styles = __webpack_require__(81301);
;// ./src/components/Icon/BaseIcon/BaseIcon.tsx
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




function BaseIcon(_a) {
    var { icon, src, className, isDisabled = false, onClick = () => null, onMouseEnter = () => null, onMouseLeave = () => null, isSmall = false, isGrey = false, style } = _a, restProps = __rest(_a, ["icon", "src", "className", "isDisabled", "onClick", "onMouseEnter", "onMouseLeave", "isSmall", "isGrey", "style"]);
    const [iconHtml, setIconHtml] = (0,external_react_.useState)(null);
    const isMounted = (0,external_react_.useRef)(false);
    (0,external_react_.useEffect)(() => {
        const controller = new AbortController();
        isMounted.current = true;
        getIconHtml(controller);
        return () => {
            isMounted.current = false;
            controller === null || controller === void 0 ? void 0 : controller.abort();
        };
    }, [icon, src]);
    const getIconHtml = (controller) => __awaiter(this, void 0, void 0, function* () {
        if (src) {
            let iconResponse = yield fetch(src, {
                signal: controller.signal,
            });
            // @ts-ignore
            setIconHtml(yield iconResponse.text());
            // @ts-ignore
            controller = null;
            return;
        }
        let iconHtml = null;
        if (icon) {
            iconHtml = icon;
        }
        // @ts-ignore
        isMounted.current && setIconHtml(iconHtml);
    });
    return ((0,jsx_runtime.jsx)("i", { "data-test": restProps['data-test'], className: classnames_default()(styles/* default */.A.i, className, {
            [styles/* default */.A.disabled]: isDisabled,
            [styles/* default */.A.smallIcon]: isSmall,
            [styles/* default */.A.greyIcon]: isGrey,
        }), 
        // @ts-ignore
        dangerouslySetInnerHTML: { __html: iconHtml }, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, style: style }));
}
/* harmony default export */ const BaseIcon_BaseIcon = (BaseIcon);

;// ./src/components/Icon/BaseIcon/index.ts

/* harmony default export */ const Icon_BaseIcon = (BaseIcon_BaseIcon);


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ Icon_IconCapedge)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: ./src/components/Icon/BaseIcon/index.ts + 1 modules
var BaseIcon = __webpack_require__(87083);
;// ./src/components/Icon/IconCapedge/capedge.inline.svg?raw
/* harmony default export */ const capedge_inlineraw = ("<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M15.9992 10.5728C15.9991 10.2973 15.999 10.0219 15.9989 9.74635C15.9987 9.21296 15.9985 8.67949 15.9983 8.14606C15.9985 7.89219 15.9988 7.35352 15.9988 7.10788C15.9989 5.57793 15.9966 5.24069 15.998 4.93292V4.93019C15.9989 4.71898 16.0018 4.56034 15.9983 4.36695C15.9973 4.31127 15.996 4.27147 15.9881 4.21796C15.9807 4.16725 15.971 4.11274 15.9463 4.04862C15.9056 3.9435 15.8302 3.8693 15.7824 3.82245C15.7431 3.78394 15.6924 3.74107 15.5977 3.67985C15.4437 3.58035 15.3218 3.5283 15.183 3.4647C15.0418 3.39994 14.9055 3.32795 14.7656 3.26137C14.7339 3.24631 14.4569 3.11142 13.9029 2.84163C13.7108 2.7481 13.4018 2.59759 13.0088 2.40541C12.6058 2.20835 12.5653 2.18789 12.342 2.07912C11.9878 1.90659 11.6991 1.7678 11.5098 1.67712C11.1948 1.83352 10.8797 1.98991 10.5646 2.14631L12.2251 2.95533C12.9562 3.31155 13.6713 3.69227 14.4184 4.02396C14.4379 4.03262 14.5164 4.06705 14.6164 4.12152C14.7008 4.16751 14.7431 4.19053 14.7841 4.2212C14.9993 4.38218 15.0336 4.62471 15.0359 4.67291C15.0376 4.70786 15.0375 4.75251 15.0375 4.75251C15.0374 4.79469 15.0372 5.00794 15.0395 5.05929C15.0395 5.06197 15.0397 5.54777 15.0397 5.55024C15.0397 5.63456 15.0398 5.71888 15.0398 5.8032C15.0398 5.89556 15.0399 5.98793 15.0399 6.08029C15.0399 6.10418 15.0403 7.03909 15.0403 7.03909C15.0404 7.25731 15.0404 7.98023 15.0403 8.22631C15.0401 8.69796 15.0406 9.06544 15.0411 9.31788C15.0412 9.35815 15.0399 9.50031 15.0416 9.69474C15.0423 9.77599 15.0426 9.76253 15.043 9.81683C15.0433 9.86191 15.0373 10.4338 15.0366 10.707C15.0359 10.9634 15.0355 11.0917 15.0359 11.1173C15.037 11.19 15.0334 11.2627 15.0338 11.3354C15.0339 11.3509 15.0343 11.3842 15.0296 11.4259C15.0276 11.4442 15.0256 11.4586 15.0233 11.4738C15.0194 11.4999 15.0147 11.5315 15.0065 11.5659C15.0065 11.5659 14.9957 11.6116 14.9792 11.6546C14.9573 11.7118 14.8145 11.9223 14.519 11.9957C14.2757 12.0561 14.0196 12.0011 13.8521 11.8846C13.7359 11.8036 13.6747 11.7011 13.6645 11.6836C13.6266 11.6187 13.6139 11.5673 13.5962 11.4923C13.5624 11.3495 13.5628 11.2243 13.5628 10.9737C13.5628 10.973 13.5629 10.9475 13.5629 10.9468C13.563 10.8828 13.563 10.8502 13.5637 10.3391C13.5644 9.79727 13.5627 8.8213 13.5599 7.24303C13.5595 7.06007 13.5597 6.87715 13.5597 6.6942C13.5596 6.36691 13.5629 6.18469 13.5594 5.89236C13.5578 5.76283 13.5557 5.6577 13.5542 5.59264C13.5573 5.52709 13.5565 5.46934 13.5542 5.42114C13.5519 5.37078 13.5505 5.34491 13.5442 5.30922C13.5295 5.22641 13.5015 5.16641 13.4907 5.1446C13.4609 5.08425 13.4279 5.04216 13.4171 5.02883C13.3917 4.99747 13.342 4.94296 13.2176 4.86391C13.1359 4.81209 8.53474 2.57617 7.99615 2.3127C7.6659 2.47134 7.33565 2.62999 7.0054 2.78864C7.16955 2.86867 7.90131 3.22546 8.06146 3.30355C8.31476 3.42702 11.8812 5.15192 12.189 5.31571C12.2607 5.35387 12.363 5.40955 12.4454 5.51442C12.5654 5.66705 12.5813 5.84533 12.5859 5.89617C12.5909 5.95167 12.5906 6.0212 12.5902 6.09955C12.5899 6.16903 12.5878 6.22661 12.586 6.26632L12.5862 6.75732C12.5862 6.84164 12.5863 6.92595 12.5863 7.01027C12.5863 7.10264 12.5864 7.19501 12.5864 7.28737C12.5864 7.31125 12.5867 8.24617 12.5867 8.24617C12.5868 8.46443 12.5868 9.18735 12.5868 9.43339C12.5865 9.90504 12.5869 10.2725 12.5875 10.525C12.5878 10.7116 12.5882 10.8021 12.588 10.9012C12.5879 10.9273 12.5879 10.9452 12.5878 10.9591C12.5877 10.9849 12.5876 11.004 12.5876 11.0073C12.5875 11.0307 12.5859 11.3925 12.5857 11.8787V12.4709C12.5862 12.5061 12.5863 12.542 12.5857 12.5785C12.5853 12.6151 12.5844 12.6509 12.5829 12.6862C12.5812 12.717 12.5755 12.76 12.5577 12.8091C12.5168 12.9222 12.4393 12.9926 12.4008 13.0266C12.3539 13.0683 12.1971 13.1956 11.9497 13.2182C11.8586 13.2265 11.7845 13.2179 11.7424 13.211C11.5189 13.1749 11.3289 13.0482 11.2353 12.8966C11.1947 12.831 11.1744 12.7642 11.1652 12.7334C11.1411 12.6526 11.1351 12.5826 11.1344 12.5324V12.4864C11.1344 12.4024 11.1344 12.3604 11.1344 12.3567C11.1337 12.2689 11.1315 12.252 11.1309 12.1616C11.1306 12.1201 11.131 12.0904 11.131 12.0708C11.1312 12.0068 11.1313 11.883 11.1318 11.527C11.1325 10.9851 11.1308 10.0092 11.128 8.43085C11.1277 8.24798 11.1279 8.06502 11.1278 7.88211C11.1277 7.53479 11.1318 7.36243 11.1275 7.08023C11.1252 6.92968 11.1217 6.80638 11.1192 6.72573C11.1186 6.66607 11.1116 6.57881 11.0806 6.47637C11.0691 6.43864 11.0592 6.40624 11.0372 6.36393C10.9804 6.25447 10.8956 6.1817 10.8486 6.14207C10.8248 6.122 10.8059 6.10794 10.7934 6.09868C10.6816 6.0157 9.70706 5.5418 9.70706 5.5418C9.70522 5.54089 9.65816 5.51718 8.89211 5.13439L7.93078 5.6028C8.27867 5.77784 9.51467 6.3898 9.53374 6.39914C9.53445 6.39949 9.53702 6.40079 9.53702 6.40079C9.83646 6.54788 9.96339 6.68122 9.96339 6.68122C10.1204 6.84618 10.1425 7.04134 10.1565 7.16589C10.1599 7.19557 10.1615 9.96613 10.1615 10.6246V13.4533C10.1615 13.4919 10.1616 13.5213 10.1618 13.5445C10.1619 13.5642 10.1619 13.5806 10.162 13.5943C10.162 13.5943 10.1621 13.6192 10.1621 13.6396C10.1622 13.7426 10.1622 13.7962 10.1523 13.8554C10.1523 13.8554 10.1347 13.9615 10.0757 14.0708C10.0492 14.1199 10.0173 14.1594 10.0173 14.1594C10.0159 14.1612 10.0147 14.1627 10.0137 14.1639C9.93873 14.255 9.84881 14.3036 9.81508 14.3214C9.61935 14.4252 9.41547 14.4155 9.36646 14.4122C9.14946 14.3974 9.00648 14.3063 8.977 14.2869C8.81259 14.1784 8.75415 14.0394 8.72765 13.97C8.68802 13.866 8.68217 13.7639 8.68146 13.7206C8.68053 13.6729 8.66715 12.854 8.66464 12.7931C8.66054 12.6938 8.66392 12.6212 8.66464 12.6033V8.08125C8.66464 8.0565 8.66469 8.03336 8.66464 7.99965C8.66439 7.89262 8.66331 7.87428 8.66239 7.86074C8.65952 7.82046 8.6549 7.78581 8.65172 7.76413C8.65003 7.75271 8.64803 7.74081 8.64578 7.72805C8.64024 7.69746 8.63542 7.67155 8.62522 7.63806C8.61097 7.59147 8.59349 7.55431 8.58 7.52887C8.53551 7.45069 8.51756 7.4362 8.50439 7.42002C8.46778 7.37515 8.43077 7.34478 8.39842 7.31848C8.36079 7.28785 8.33009 7.26691 8.30892 7.25255C8.2941 7.24251 8.22294 7.19466 8.11395 7.1389C8.09565 7.12959 8.08197 7.12289 8.07786 7.1209C7.91054 7.03913 6.98315 6.57163 5.44028 5.81626C5.43998 5.81609 5.44039 5.8163 3.81452 5.02412C2.6404 4.45205 2.64035 4.45201 2.64035 4.45201C2.49147 4.38075 2.34542 4.30522 2.19732 4.23284C2.10258 4.18659 2.07741 4.17647 1.99005 4.13519C1.55553 3.92982 1.54779 3.90538 1.35724 3.82686C1.10291 3.72208 0.975724 3.66968 0.791324 3.67289C0.734882 3.67388 0.536231 3.67959 0.344244 3.79294C0.344244 3.79294 0.146771 3.90953 0.0727955 4.07571C0.0673615 4.08791 0.0624402 4.1005 0.0624402 4.1005C0.0600308 4.10673 0.0566983 4.11564 0.0529047 4.12645C0.0529047 4.12645 0.0327059 4.1843 0.0210175 4.2414C0.00999551 4.29527 0.0077409 4.34709 0.00702319 4.42229C0.00630548 4.50076 0.00589459 4.54 0.00912428 4.61796C0.0109186 4.6617 0.00989326 4.6749 0.00912428 4.97263C0.00789393 5.42776 0.00256314 5.65506 0.00702319 5.84512C0.0077409 5.87657 0.00963693 5.94454 0.00912428 6.03664C0.00871417 6.11413 0.00707445 6.11914 0.00702319 6.19269C0.00702319 6.21047 0.00707365 6.2482 0.00492052 6.29907C0.00399775 6.32084 0.00302448 6.33689 0.00281942 6.33987C-0.00528043 6.4755 0.00912428 7.15741 0.00912428 7.15741C0.0102521 7.20985 0.012354 7.31986 0.013328 7.46064C0.0146097 7.64983 0.0129187 7.76608 0.0112269 7.96781C0.0095352 8.1721 0.00820113 8.3304 0.00840619 8.52231C0.00876504 8.84168 0.0130725 8.90848 0.0112269 9.19674C0.0102529 9.35132 0.00891999 9.34972 0.00702319 9.5319C0.00164037 10.0491 0.0125085 10.0461 0.00702319 10.4115C0.00333211 10.6587 -0.00405008 10.8165 0.00281942 11.1049C0.005639 11.2238 0.00717625 11.2843 0.013328 11.339C0.027067 11.4612 0.0570577 11.7277 0.228641 11.9974C0.404685 12.2741 0.63958 12.4435 0.90221 12.5892C1.60182 12.9771 1.9516 13.1711 7.4571 15.8309C7.55276 15.8771 7.78232 15.9917 8.09468 15.9996C8.40232 16.0073 8.67659 15.9085 8.77809 15.8711C8.8877 15.8306 8.94004 15.8008 9.12551 15.7056C9.3622 15.584 9.60443 15.4701 9.84276 15.3509C9.86998 15.3373 9.89572 15.3245 9.92089 15.312C9.92099 15.3123 9.92109 15.3127 9.9212 15.313L12.6436 13.9828L12.6437 13.9866C12.6644 13.9766 12.8117 13.9047 12.8324 13.8945C13.0638 13.7817 13.4288 13.6038 13.8224 13.4121C13.8224 13.4103 13.8224 13.4086 13.8224 13.4069L15.0515 12.8063C15.0822 12.8098 15.2084 12.7289 15.2146 12.7257C15.2149 12.7257 15.2165 12.7248 15.2188 12.7236C15.2254 12.7202 15.2316 12.717 15.2928 12.6855C15.3473 12.6575 15.3559 12.6531 15.3721 12.644C15.412 12.6216 15.4403 12.6031 15.448 12.5979C15.4576 12.5916 15.4868 12.572 15.5233 12.5433C15.5473 12.5243 15.5838 12.4953 15.6249 12.4532C15.6704 12.4066 15.6999 12.366 15.7252 12.3311C15.7252 12.3311 15.7409 12.3094 15.7558 12.2872C15.8484 12.1482 15.8993 12.0116 15.8993 12.0116C15.9376 11.9085 15.9516 11.8263 15.9653 11.7457C15.9673 11.7339 15.9758 11.683 15.9831 11.615C15.9851 11.5958 15.9905 11.5426 15.9948 11.4408C15.9959 11.4145 15.9984 11.3396 15.9994 11.1527C15.9997 11.092 15.9995 11.0489 15.9994 11.0144C15.9989 10.9162 15.9986 10.7708 15.9992 10.5728Z\" />\n<path d=\"M10.4091 1.13323C10.0682 0.970604 9.72588 0.805858 9.38215 0.638907C8.94393 0.426053 8.51049 0.213027 8.08176 0C7.75997 0.156785 7.43818 0.31357 7.11644 0.470354L9.44454 1.60319L10.4091 1.13323Z\" />\n<path d=\"M6.85844 1.75158C6.4636 1.5617 6.06876 1.37187 5.67391 1.18199C5.34592 1.3418 5.01788 1.50165 4.68983 1.66147C4.90407 1.76197 5.11948 1.86411 5.33603 1.96794C5.51791 2.05525 5.69821 2.14251 5.87687 2.22986L6.85844 1.75158Z\" />\n<path d=\"M7.795 4.57711C6.70582 4.03991 5.60686 3.50384 4.49815 2.96903C4.08198 2.76824 3.66633 2.56858 3.25129 2.37005C2.9277 2.52718 2.60412 2.68431 2.28053 2.84144L6.81446 5.04872C7.14132 4.89154 7.46819 4.73432 7.795 4.57711Z\" />\n</svg>\n");
;// ./src/components/Icon/IconCapedge/IconCapedge.tsx



const IconCapedge = (props) => ((0,jsx_runtime.jsx)(BaseIcon["default"], Object.assign({ icon: capedge_inlineraw }, props)));
/* harmony default export */ const IconCapedge_IconCapedge = (IconCapedge);

;// ./src/components/Icon/IconCapedge/index.ts

/* harmony default export */ const Icon_IconCapedge = (IconCapedge_IconCapedge);

})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map